import uuidv4 from 'uuidv4';
import moment from 'moment';

import { getKeyByValue, convertToCurrency, convertNumberBR, convertPercentage, convertDate, convertDateTime, toCapitalizeCase } from 'utils/helpers';

const typeLegEnums = {
  call: 22,
  put: 33,
  spot: 35
};

export const normalizeAssets = (assets) => {
  const normalizedAssets = assets
    .map(asset => ({
      ...asset,
      label: asset.nomeAtivo,
      value: asset.nomeAtivo
    }))
    .sort((a, b) => (
      b.value > a.value ? -1: 1
    ));
  return normalizedAssets;
};

const normalizeOpcao = (option) => {
  let value;
  switch (option.toUpperCase()) {
    case 'CALL':
      value = typeLegEnums.call;
      break;
    case 'PUT':
      value = typeLegEnums.put;
      break;
    case 'SPOT':
      value = typeLegEnums.call;
      break;
    default:
      value = 0;
      break;
  }

  return {
    value,
    label: toCapitalizeCase(option),
  }
};

const normalizeLegs = (legs, hasBuyAsset) => {
  const normalizedLegs = legs?.map(leg => ({
    ...leg,
    tipoOpcao: 2,   // 1 AMERICANA e 2 EUROPEIA
    estiloOpcao: 2, // 2 FLEX
    reverse: false,
    isVisible: true,
    compraAtivo: hasBuyAsset,
    opcao: normalizeOpcao(leg?.opcao),
  }));
  return normalizedLegs;
};

export const normalizeStrategies = (strategies) => {
  const strategiesFormatted = strategies
    ?.map(strategie => {
      const { dscPerna } = strategie;
      const vertices = JSON.parse(dscPerna).vertices;
      const structureName = toCapitalizeCase(strategie.nomeEstrutura);
      const hasBuyAsset = Boolean(vertices.find(leg => leg.opcao === typeLegEnums.spot));

      return {
        ...strategie,
        value: structureName,
        label: structureName,
        compraAtivo: hasBuyAsset,
        vertices: normalizeLegs(vertices, hasBuyAsset)
      }
    })
    .sort((a, b) => (
      b.value > a.value ? -1: 1
    ));

  return strategiesFormatted;
};

export const normalizeQuotes = (quotes) => {
  const normalizedQuotes = quotes?.map(quote => {
    const hasBuyAsset = Boolean(quote?.pernas.find(quote => quote.tipoPerna === typeLegEnums.spot));

    const legs = quote?.pernas.map(leg => ({
      ...leg,
      operacao: leg?.lado,
      asset: leg?.nomeAtivo,
      maturityDate: moment(leg.datVencimento),
      spotFormatted: convertNumberBR(leg.valorAtivo),
      opcao: getKeyByValue(typeLegEnums, leg.tipoPerna),
      maturityDateFormatted: convertDate(leg.datVencimento),
      operationFormatted: leg.lado === 'V' ? 'Venda' : 'Compra',
      quantity: {
        view: convertNumberBR(leg.quantidade),
        value: leg.quantidade,
      },
      strike: {
        value: leg.valorStrike,
        view: convertToCurrency(leg.valorStrike),
        converted: quote.indRolagem ? '-' : convertPercentage(leg.valorStrike)
      }
    }));

    return {
      ...quote,
      id: uuidv4(),
      asset: legs[0]?.nomeAtivo,
      compraAtivo: hasBuyAsset,
      reverse: quote.indRolagem,
      vertices: normalizeLegs(legs, hasBuyAsset),
      data: convertDateTime(quote?.dtInclusao, true),
      commissionFormatted: convertToCurrency(quote.valorComissao),
      indicativePriceFormatted: convertToCurrency(quote.valorEstrutura),
      endPriceFormatted: convertToCurrency(quote.valorComissao+quote.valorEstrutura),
    }
  });
  return normalizedQuotes;
};
